export const separateNumberByComas = (number: number) =>
  `${number}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
